import { NgComponentOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    effect,
    EventEmitter,
    inject,
    input,
    Output,
} from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
    getNotificationComponent,
    NOTIFICATION_CONFIG,
    NotificationEvent,
} from '@interacta-shared/data-access-notification';
import { TranslatePipe } from '@ngx-translate/core';
import { NotificationPanelService } from '../../services/notification-panel.service';
import { UnknownNotificationComponent } from '../unknown-notification/unknown-notification.component';

@Component({
    selector: 'interacta-notification-panel-item',
    imports: [TranslatePipe, MatTooltipModule, NgComponentOutlet],
    templateUrl: './notification-panel-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'relative',
    },
})
export class NotificationPanelItemComponent {
    readonly notificationPanelService = inject(NotificationPanelService);
    private readonly config = inject(NOTIFICATION_CONFIG);

    notification = input.required<NotificationEvent>();
    private readonly typeId = computed(() => this.notification().typeId);

    readonly component = computed(
        () =>
            getNotificationComponent(this.config, this.typeId()) ??
            UnknownNotificationComponent,
    );

    readonly componentInputs = computed(() => ({
        notification: this.notification(),
    }));

    @Output() markAsRead = new EventEmitter<void>();

    constructor() {
        effect(() => {
            if (this.component() === UnknownNotificationComponent) {
                console.warn(
                    'No component is configured to handle this notification event. Please check your NotificationConfig instance',
                    this.notification(),
                );
            }
        });
    }
}
